<div class="card-outline">
  <div class="usf-product-card-warning-msg">
    <p
      [attr.data-cy]="
        'product-warning-message-' + product?.productNumber + '-text'
      "
      class="bold"
    >
      <ion-icon
        [attr.data-cy]="
          'product-warning-message-' + product?.productNumber + '-icon'
        "
        name="close-circle-outline"
      ></ion-icon>
      {{ product?.productCardWarningMsg?.primaryText | translate }}
      <span
        [attr.data-cy]="
          'product-warning-message-' + product?.productNumber + '-subtext1'
        "
      >
        {{ product?.productCardWarningMsg?.secondaryText | translate }}
      </span>
      <span
        [attr.data-cy]="
          'product-warning-message-' + product?.productNumber + '-subtext2'
        "
      >
        {{ product?.productCardWarningMsg?.secondaryTextDate | translate }}
      </span>
      <span
        [attr.data-cy]="
          'product-warning-message-' + product?.productNumber + '-boldtext1'
        "
      >
        <b> {{ product?.productCardWarningMsg?.boldedText | translate }}</b>
      </span>
    </p>
  </div>

  <div
    class="product-info-ordering-row"
    [class.power-review]="
      mode === productCardModes.defaultSearch && !!powerReviewRollupModel
    "
  >
    <div class="product-info-column">
      <app-product-card-information
        [brand]="product?.summary?.brand"
        [description]="product?.summary?.productDescTxtl"
        [productNumber]="product?.productNumber"
        [salesPackSize]="product?.summary?.salesPackSize"
        [note]="product?.item?.note"
        [showNote]="false"
        [notFound]="product?.notFound"
        [isSplitCard]="true"
        [customerProductNumber]="product?.customerProductNumber"
        [powerReviewRollupModel]="powerReviewRollupModel"
        [showPowerReview]="
          mode === productCardModes.defaultSearch && !!powerReviewRollupModel
        "
        [pricePerPortion]="product?.pricePerPortion"
        (itemNoteClickEmitter)="itemNoteClick()"
        (productDescriptionClickEmitter)="productClick()"
        [truncateAmount]="
          platformService.platformType === platformService.platformEnum.desktop
            ? 53
            : platformService.platformType ===
              platformService.platformEnum.mobile
            ? 30
            : 25
        "
        [clickable]="clickable"
        [isGuestUser]="isGuestUser"
      >
      </app-product-card-information>
    </div>
    <div class="product-ordering-column">
      <app-product-card-ordering
        [productSummary]="product?.summary"
        [pricing]="product?.pricing"
        [casesOrdered]="product?.casesOrdered"
        [eachesOrdered]="product?.eachesOrdered"
        [isOrderable]="product?.orderable"
        [isOnline]="panAppState.online$ | async"
        [platformType]="this.platformService?.platformType"
        [index]="index"
        [listId]="listId"
        [hotkeyIds]="product?.hotkeyIds"
        [pricingDisabled]="pricingDisabled"
        [mode]="mode"
        [notFound]="product?.notFound"
        [hideQuantityBoxes]="product?.hideQuantityBoxes"
        [isSplitCard]="true"
        (quantityUpdateEmitter)="changeQuantityHandler($event)"
        (quantityElementEmitter)="quantityInputUpdate($event)"
        (mouseover)="handleMouseOver($event)"
        (mouseleave)="handleMouseLeave()"
        [isGuestUser]="isGuestUser"
      >
      </app-product-card-ordering>
    </div>
  </div>
  <div
    *ngIf="
      (mode !== productCardModes.listManagement &&
        mode !== productCardModes.addToInventory &&
        product?.promotionDetails) ||
      showNotes
    "
    class="product-note-promotions-row"
  >
    <div class="product-note-column">
      <app-product-card-item-note
        *ngIf="showNotes"
        [note]="
          product?.item
            ? product?.item?.note
            : product?.masterListItem?.referenceComment
        "
        [productNumber]="product?.productNumber"
        [truncateAmount]="
          platformService.platformType === platformService.platformEnum.desktop
            ? 50
            : platformService.platformType ===
              platformService.platformEnum.mobile
            ? 30
            : 25
        "
        (itemNoteClickEmitter)="itemNoteClick()"
      ></app-product-card-item-note>
    </div>
    <div class="product-promotions-column">
      <app-product-card-promotions-banner
        *ngIf="
          mode !== productCardModes.listManagement &&
          mode !== productCardModes.addToInventory &&
          product?.promotionDetails
        "
        [offerBenefitDesc]="product?.promotionDetails?.offerBenefitDesc"
        [productNumber]="product?.summary?.productNumber"
        (bannerClickEmitter)="promotionClick($event)"
      >
      </app-product-card-promotions-banner>
    </div>
  </div>
  <div class="product-tags-line-number-row">
    <div class="product-tags-column">
      <app-usf-product-tag-list
        [tagList]="product?.productTags"
        [infoIconEnabled]="false"
        [allTagsClickable]="true"
        [product]="transformProductToProductDetail()"
        [maxTags]="2"
      >
      </app-usf-product-tag-list>
    </div>
    <div class="product-line-number-column">
      <app-product-card-line-number
        *ngIf="
          mode === productCardModes.listDetail ||
          mode === productCardModes.listManagement ||
          mode === productCardModes.productNumberSearch
        "
        [sequenceNumber]="sequenceNumber"
        [isListManagement]="mode === productCardModes.listManagement"
        (resequenceProductEmitter)="resequenceProduct($event)"
      >
      </app-product-card-line-number>
    </div>
  </div>
</div>
